
const loginAccount = document.querySelector(".utility_link.account-button");
const closeButton = document.querySelector(".close_account_button");
let dropdownMenu = document.querySelector(".dropdown-menu_account.LoginDrop");
let accountMenu = document.querySelector(".loginMobile.large-up-hide");
let overlayAccount = document.querySelector(".dropdown-overlay");
const dropDownContainer = document.querySelector(".dropdown-menu.LoginDrop");
const dropdownLinks = document.querySelectorAll(
  ".dropdown-menu.LoginDrop li.dropdown-li .linkHover, .address_book-list li a "
);


document.addEventListener('click', function(event) {
  if (event.target.closest('.utility_link.account-button')) {
      if (dropDownContainer?.classList.contains("show")) {
          dropDownContainer.classList.remove("show"); 
      } else {
          dropDownContainer?.classList.add("show"); 
      }
      return;
  }
  if (dropDownContainer && !event.target.closest('.dropdown-menu.LoginDrop')) {
      dropDownContainer.classList.remove('show');
  }
});


if (dropdownLinks) {
  dropdownLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();

      var href = this.getAttribute("href");
      localStorage.setItem("lastClickedHref", href);
      window.location.href = "/account";
    });
  });
}

var lastClickedHref = localStorage.getItem("lastClickedHref");
if (lastClickedHref) {
  var profileLink = document.querySelector(
    '.profile-navigation li a[href="' + lastClickedHref + '"]'
  );

  setTimeout(() => {
    if (profileLink) {
      profileLink.click();
      localStorage.removeItem("lastClickedHref");
    }
  }, 500);
}
const menuCartIcon = document.querySelector(
  ".header__icon.header__icon--cart.focus-inset.medium-hide.small-hide"
);
let cartDrawer = document.querySelector("cart-drawer.drawer");
if (menuCartIcon) {
  menuCartIcon.addEventListener("click", () => {
    let headerGroup = document.querySelector(
      ".shopify-section-header-sticky"
    );

    function updateCartDrawerPosition() {
      if (window.innerWidth > 990) {
        
          if (headerGroup && cartDrawer) {
            let headerHeight = headerGroup.offsetHeight;
            let headerTop = headerGroup.getBoundingClientRect().top;
            let topValue = headerHeight + headerTop;
            cartDrawer.style.top = `${topValue}px`;
          }
        }
    }
    updateCartDrawerPosition();

    setTimeout(() => {
      cartDrawer.classList.add("animate", "active");
    });

    window.addEventListener("scroll", updateCartDrawerPosition);
  });
}

if (window.innerWidth <= 750) {
  const navTrigger = document.getElementById("navTrigger");
  const navList = document.querySelector(".profile-navigation");

  navList?.classList.add("hidden");

   navTrigger?.addEventListener('click', function() {
    navList.classList.toggle('hidden');
    navTrigger.classList.toggle('navTriggerActive');
  });

  const navListItems = document.querySelectorAll(".profile-navigation li a");
  navListItems?.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const content = this.innerHTML;
      navTrigger.innerHTML = content; // Update innerHTML of navTrigger directlynavList.classList.add('hidden');
      navList.classList.add("hidden");
      navTrigger.classList.toggle("navTriggerActive");
    });
  });
}

accountMenu?.addEventListener("click", function () {
  if (dropdownMenu) {
    dropdownMenu.classList.add("show");
  }
});
const dropDowncloseIcon = document.querySelector('.dropdown-menu_account .close_account_button');
dropDowncloseIcon?.addEventListener('click', () => {
  dropdownMenu.classList.remove("show");
})
document.addEventListener("click", function (event) {
  if (
    event.target.classList.contains("dropdown-overlay") ||
    event.target.classList.contains("close_account_button") ||
    event.target.classList.contains("icon-close")
  ) {
    dropdownMenu.classList.remove("show");
  }
});
  document.querySelector(".view_all_recentorder")?.addEventListener("click", function() {
  document.getElementById("orders").style.display = "block";
  document.getElementById("account").style.display = "none";

  let navItems = document.querySelectorAll("ul.profile-navigation li");
  navItems.forEach(li => li.classList.remove("active"));

  if (navItems.length >= 3) {
      navItems[2].classList.add("active");
  }
});

const countryCurrency = {
  GB: "UK",
};

//shipping
document.addEventListener("DOMContentLoaded", function () {
  const freeShippingCard = document.querySelector(
    ".free-shipping-progress-card"
  );
  if (freeShippingCard) {
    const messageCart = document.querySelector(".message-cart");
    const shippingElement = document.querySelector(
      ".shipping.cart-footer-details"
    );
    const calculateShippingDifference = (
      totalCartValue,
      freeShippingThreshold
    ) => totalCartValue - freeShippingThreshold;

    const getShippingMessage = (
      shippingDifference,
      shippingSymbol,
      shippingCountryCode,
      modifiedCartMessage
    ) => {
      const dataFreeShippingfulfill = messageCart.getAttribute(
        "data-shipping-fulfill"
      );
      if (shippingDifference >= 0) {
        freeShippingCard.classList.remove("free-shipping-in-progress");
        freeShippingCard.classList.add("free-shipping-bar");
        if (window.location.href.indexOf("cart") !== -1) {
          if (shippingElement) {
            shippingElement.classList.remove("hidden");
          }
        }

        return `${dataFreeShippingfulfill}${
          shippingCountryCode ? ` in the ${shippingCountryCode}.` : ""
        }`;
      } else {
        freeShippingCard.classList.remove("free-shipping-bar");
        freeShippingCard.classList.add("free-shipping-in-progress");
        if (window.location.href.indexOf("cart") !== -1) {
          if (shippingElement) {
            shippingElement.classList.add("hidden");
          }
        }
        return modifiedCartMessage;
      }
    };

    window.updateCartForShippingProgress = function () {
      if (freeShippingCard) {
        freeShippingCard.classList.add("loading");
      }
      fetch("/cart.js")
        .then((response) => response.json())
        .then((data) => {
          const dataFreeShipping =
            messageCart.getAttribute("data-free-shipping");
          const totalPriceFromCart = Number(data.total_price) / 100;
          const freeShippingDK = Number(dataFreeShipping);
          const shippingSymbol = document
            .querySelector("header")
            .getAttribute("data-currency-symbol");
          const shippingCountry = freeShippingCard.getAttribute("data-country");
          const cartMessage = messageCart.getAttribute("data-text");
          const countryName = shippingCountry;
          let shippingCountryCode = "";
          
          if (countryCurrency.hasOwnProperty(countryName)) {
            shippingCountryCode = countryCurrency[countryName];
          } else {
            //console.log("Currency symbol not found for the given country.");
          }
          const shippingDifference = calculateShippingDifference(
            totalPriceFromCart,
            freeShippingDK
          );
          const modifiedCartMessage = cartMessage.replace(
            "Free_shipping_progress",
            shippingSymbol === '€' 
            ? `<b>${shippingSymbol}${Math.abs(shippingDifference).toFixed(2)}</b>`
            : `<b>${shippingSymbol} ${Math.abs(shippingDifference).toFixed(2)}</b>`
          );
          const shippingMessage = getShippingMessage(
            shippingDifference,
            shippingSymbol,
            shippingCountryCode,
            modifiedCartMessage
          );
          "shippingMessage", shippingMessage;

          const progressBar = document.querySelector(".text-progress");
          const freeShipping__Card = document.querySelector(
            ".free-shipping-progress-card"
          );

          progressBar.innerHTML = `<div>${shippingMessage}</div>`;

          freeShipping__Card.classList.remove("loading");
        })
        .catch((error) => {
          console.error("Error fetching cart total:", error);
        });
    };
    window.updateCartForShippingProgress();
  }
});

const originalFetch = window.fetch;

window.fetch = async function (...args) {
  const response = await originalFetch.apply(this, args);
  const clonedResponse = response.clone();

  if (args[0].includes("cart.js") || args[0].includes("add.js")) {
    clonedResponse
      .json()
      .then((data) => {
        if (Array.isArray(data)) return;

        const itemCount = data.item_count;
        const totalPrice = data.items_subtotal_price;

        if (itemCount === undefined || totalPrice === undefined) return;

        const headerEl = document.querySelector("header.header[data-currency-formate]");
        if (!headerEl) return;

        const exampleFormatted = headerEl.getAttribute("data-currency-formate");
        const formattedPrice = applySmartCurrencyFormat(exampleFormatted, totalPrice);

        const cartIconBubble = document.querySelector("#cart-icon-bubble .m-5 span");
        if (cartIconBubble) cartIconBubble.innerText = itemCount;

        const cartTotalPrice = document.querySelector(".cart-total_price .price-total");
        if (cartTotalPrice) cartTotalPrice.innerHTML = formattedPrice;
      })
      .catch((err) => {
        console.error("Error parsing JSON response:", err);
      });
  }

  return response;
};

// Dynamically match currency style from example
function applySmartCurrencyFormat(exampleFormatted, amountInCents) {
  const numberMatch = exampleFormatted.match(/[\d\s.,]+/);
  if (!numberMatch) return "";

  const exampleNumber = numberMatch[0];
  const currencySymbol = exampleFormatted.replace(exampleNumber, "").trim();

  const isPrefix = exampleFormatted.trim().startsWith(currencySymbol);

  const hasComma = exampleNumber.includes(",");
  const hasDot = exampleNumber.includes(".");

  const useDecimals = hasComma || hasDot;
  const decimalSeparator = hasComma ? "," : ".";
  const thousandsSeparator = hasComma && hasDot ? "." : hasDot ? "." : hasComma ? "," : " ";

  let amount = amountInCents / 100;

  let [integer, decimal] = amount.toFixed(2).split(".");
  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

  let formatted = useDecimals ? `${integer}${decimalSeparator}${decimal}` : integer;

  return isPrefix ? `${currencySymbol} ${formatted}` : `${formatted} ${currencySymbol}`;
}






window.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 990) {
    const handleCollapse = (heading) => {
      if (heading.classList.contains("block-collapsed")) {
        document
          .querySelectorAll(".grid .footer-block__heading")
          .forEach((heading, index) => {
            heading.classList.add("block-collapsed");
            heading.setAttribute("aria-expanded", "false");
          });

        heading.classList.remove("block-collapsed");
        heading.setAttribute("aria-expanded", "true");
      } else {
        heading.classList.add("block-collapsed");
        heading.setAttribute("aria-expanded", "false");
      }
    };

    document
      .querySelectorAll(".grid .footer-block__heading")
      .forEach((heading, index) => {
        heading.classList.add("block-collapsed");
        heading.setAttribute("role", "button");
        heading.setAttribute("aria-expanded", "false");
        heading.setAttribute("tabindex", "0");

        heading.nextElementSibling.setAttribute(
          "id",
          `footer-block-index-${index}`
        );
        heading.setAttribute("aria-controls", `footer-block-index-${index}`);

        heading.addEventListener("click", () => {
          handleCollapse(heading);
        });
        heading.addEventListener("keypress", () => {
          handleCollapse(heading);
        });
      });
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.querySelector(".cart-drawer");

  document.addEventListener("click", (event) => {
    if (cartDrawer && !cartDrawer.contains(event.target)) {
      const cartDrawerElement = document.querySelector("cart-drawer");
      if (cartDrawerElement && cartDrawerElement.classList.contains("active")) {
        cartDrawerElement.classList.remove("active");
      }
    }
  });

  const cartDrawerElement = document.querySelector("#CartDrawer");
  if (cartDrawerElement) {
    cartDrawerElement.addEventListener("click", (event) => {
      event.stopPropagation();
    });
  }
});

window.calculateTotalSaving = function () {
  if (window.location.href.includes("cart")) {
    var savingPrices = document.querySelector(".saving-heading");
    var subTotalAmout_with_savings = document.querySelector(".sub-total .bold");
    var savingContainer = document.querySelector(".saving"); // Select the saving div

    if (!savingPrices) return; // If savingPrices is not found, exit function

    var savingString =
      savingPrices.getAttribute("data-cart-total-saving") || "0";
    var subTotalAmout_with_savings_attribute =
      savingPrices.getAttribute("data-subtotal-plus-saving") || "0";

    console.log("savingString", savingString);

    const savingTotalElement = document.querySelector(".saving-total-price");

    // if (savingTotalElement) {
    //   savingTotalElement.textContent = savingString;
    //   subTotalAmout_with_savings.textContent =
    //     subTotalAmout_with_savings_attribute;
    // }

    // Convert savingString to a number and check if it's less than or equal to zero
    // if (parseFloat(savingString.replace(/[^\d.-]/g, "")) <= 0) {
    //   savingContainer.classList.add("hidden"); // Add hidden class if savings are 0 or less
    // } else {
    //   savingContainer.classList.remove("hidden"); // Remove hidden class if savings exist
    // }
  }
};
window.calculateTotalSaving();


// ----------------------Comfort points update on cart page-----------
document.addEventListener("DOMContentLoaded", function () {
  window.updateComfortPoints = function () {
    if (window.location.href.includes("cart")) {
      var comfort_point_div = document.querySelector(".comfort_point_div");
      if (comfort_point_div) {
        comfort_point_div.classList.add("loading");
        fetch("/cart.js")
          .then((response) => response.json())
          .then((data) => {
            var totalPrice = Number(data.total_price) / 10;
            var comfortPointsPerDollar = 100;
            var comfortPointsEarned = Math.round(
              totalPrice / comfortPointsPerDollar
            );
            
            var chkComfortPoints = document.querySelector(".chkComfortPoints");
            var chkComfort_text = document.querySelector(".chkComfortPoints").getAttribute("data-comfort-point-text");
            if (chkComfort_text) {
              var replacementText = chkComfort_text.replace(
                "comfort_points",
                "<strong>" + comfortPointsEarned + "</strong>"
              );
              chkComfortPoints.innerHTML = replacementText;
            }
            comfort_point_div.classList.remove("loading");
          })
          .catch((error) => {
            console.error("Error fetching cart total:", error);
          });
      }
    }
  };

  updateComfortPoints();
});


document.addEventListener("click", function (event) {
  // Check if the clicked element is the 'eyeIcon'
  if (event.target.classList.contains("newFieldIcon-passwordEye")) {
    // Toggle the eye icon state
    event.target.classList.toggle("fa-eye");
    event.target.classList.toggle("fa-eye-slash");
    event.target.classList.toggle("showPassword");

    // Find the input element associated with this icon using the `toggle` attribute
    const inputSelector = event.target.getAttribute("toggle");
    if (inputSelector) {
      const input = document.querySelector(inputSelector);

      if (input) {
        // Toggle the input type between 'password' and 'text'
        input.type = input.type === "password" ? "text" : "password";
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const dayDropdown = document.getElementById("select-day");
  const monthDropdown = document.getElementById("select-month");
  const yearDropdown = document.getElementById("select-year");

  if (!dayDropdown || !monthDropdown || !yearDropdown) {
    //console.error("Dropdown elements not found!");
    return;
  }

  for (let day = 1; day <= 31; day++) {
    let option = document.createElement("option");
    option.value = day;
    option.textContent = day;
    dayDropdown.appendChild(option);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  months.forEach((month, index) => {
    let option = document.createElement("option");
    option.value = index + 1;
    option.textContent = month;
    monthDropdown.appendChild(option);
  });

  const currentYear = new Date().getFullYear();
  const startYear = 1920;

  for (let year = currentYear; year >= startYear; year--) {
    let option = document.createElement("option");
    option.value = year;
    option.textContent = year;
    yearDropdown.appendChild(option);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const bannerNavigationButtons = document.querySelectorAll(
    ".banner-navigation__button"
  );
  bannerNavigationButtons?.forEach((eachButton) => {
    eachButton.addEventListener("click", (event) => {
      event.preventDefault();
      const navigationSection = document.querySelector(
        `${eachButton.getAttribute("href")}`
      );
      console.log(navigationSection);
      if (navigationSection) {
        const sectionOffsetTop = navigationSection.offsetTop;

        // Scroll to the calculated position smoothly
        window.scrollTo({
          top: sectionOffsetTop - 100,
          behavior: "smooth",
        });
      }
    });
  });
});

// Address Book Validation code start
document.addEventListener("DOMContentLoaded", function () {
  let previousValues = {}; // Store previous input values

  // Store initial values of inputs when the page loads
  document.querySelectorAll("input, select").forEach((input) => {
    previousValues[input.id] = input.value;
  });

  document.querySelectorAll(".add-button_validate").forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      
      let form = this.closest("form");
      let allFilled = true;

      form.querySelectorAll(".field.input-wrapper").forEach((wrapper) => {
        let input = wrapper.querySelector("input, select");
        let errorSpan = wrapper.nextElementSibling;

        if (input) {
          let inputName = input.getAttribute("name");

          if (
            inputName === "address[address2]" ||
            inputName === "address[company]"
          ) {
            return; // Skip validation for these fields
          }

          let isEmpty =
            input.tagName.toLowerCase() === "input"
              ? input.value.trim() === ""
              : input.value === "" ||
                input.value === null ||
                input.selectedIndex === 0;

          let isInvalidNumber =
            inputName === "address[phone]" &&
            input.value.replace(/\D/g, "").length !== 10;

          if (isEmpty || isInvalidNumber) {
            allFilled = false;
            console.log(
              `Field is invalid: Name="${inputName}", ID="${input.id}"`
            );
            if (errorSpan && errorSpan.classList.contains("error-text")) {
              errorSpan.classList.remove("visibility-hidden");
            }
            window.scrollTo({
              top: 0,
              behavior: 'smooth' // This makes the scroll smooth
            });
          } else {
            if (errorSpan && errorSpan.classList.contains("error-text") && !isInvalidNumber) {
              errorSpan.classList.add("visibility-hidden");
            }
          }
        }
      });

      if (allFilled) {
        let submitButton = event.target.previousElementSibling;
        if (submitButton) {
          submitButton.click();
        }
      }
    });
  });

  // Restore values when clicking the back button
  document.querySelectorAll(".backbutton").forEach((backButton) => {
    backButton.addEventListener("click", function () {
      document.querySelectorAll(".edit-address-input").forEach((input) => {
        if (previousValues.hasOwnProperty(input.id)) {
          input.value = previousValues[input.id]; // Restore previous value
        }
      });

      // Hide all error messages
      document.querySelectorAll(".error-text").forEach((error) => {
        error.classList.add("visibility-hidden");
      });
    });
  });
});
// Address Book Validation code end
function clickChatContainer() {
    const chatContainer = document.getElementById('mobile-chat-container');
    if (chatContainer) {
        chatContainer.click();
    }
}

